export default __webpack_public_path__ + "static/media/IMG_1978.6affb5c6.JPG";